import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useLocation } from 'react-router';

const accountsPath = '/admin/accounts';
const tenantsPath = '/admin';

/**
 * Administration is two registries kept apart: the tenants work is filed under and the Flowis
 * accounts they act through. The standard code lists are an administrator's call too, but a section
 * of their own in the left bar — they answer per tenant, which these two do not. Who may act for a
 * tenant is not a registry here at all: the directory says, through the caller's tenant.{code}
 * app roles.
 */
export function AdminSectionTabs() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  // A single tenant's page still belongs to the tenants section, so only the explicit sub-route
  // switches away from it.
  const value = pathname.startsWith(accountsPath) ? accountsPath : tenantsPath;

  return (
    <Tabs value={value}>
      <Tab value={tenantsPath} label={t('admin.tabs.tenants')} component={RouterLink} to={tenantsPath} />
      <Tab value={accountsPath} label={t('admin.tabs.accounts')} component={RouterLink} to={accountsPath} />
    </Tabs>
  );
}
